// class StickyAtc extends HTMLElement {
//   connectedCallback() {
//     const stickyAtc = this;
//     const hideEnd = stickyAtc.hasAttribute("hide-end");

//     const button = stickyAtc.querySelector(".sticky-atc__button");

//     const targetSelector =
//       stickyAtc.getAttribute("target-selector") || button?.getAttribute("href");

//     const hideSelectorsRaw = stickyAtc.getAttribute("hide-selectors") || "";

//     const hideSelectors = hideSelectorsRaw
//       .split(",")
//       .map((selector) => selector.trim())
//       .filter(Boolean);

//     const targetSection = this.safeQuerySelector(targetSelector);

//     if (!stickyAtc || !targetSection) return;

//     let targetOutOfView = false;
//     let reachedEnd = false;
//     let insideHiddenSection = false;

//     const hiddenSections = hideSelectors
//       .map((selector) => this.safeQuerySelector(selector))
//       .filter(Boolean);

//     const updateReachedEnd = () => {
//       const scrollPos = window.scrollY + window.innerHeight;
//       const docHeight = document.documentElement.scrollHeight;

//       reachedEnd = hideEnd && scrollPos >= docHeight - 20;
//     };

//     const updateStickyState = () => {
//       if (targetOutOfView && !reachedEnd && !insideHiddenSection) {
//         stickyAtc.classList.add("visible");
//       } else {
//         stickyAtc.classList.remove("visible");
//       }
//     };

//     const targetObserver = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           targetOutOfView = !entry.isIntersecting;
//           updateStickyState();
//         });
//       },
//       {
//         threshold: 0,
//       },
//     );

//     targetObserver.observe(targetSection);

//     if (hiddenSections.length > 0) {
//       const hiddenObserver = new IntersectionObserver(
//         (entries) => {
//           insideHiddenSection = entries.some((entry) => entry.isIntersecting);
//           updateStickyState();
//         },
//         {
//           threshold: 0,
//           rootMargin: "0px 0px -20% 0px",
//         },
//       );

//       hiddenSections.forEach((section) => {
//         hiddenObserver.observe(section);
//       });
//     }

//     const handleScroll = () => {
//       updateReachedEnd();
//       updateStickyState();
//     };

//     const handleResize = () => {
//       updateReachedEnd();
//       updateStickyState();
//     };

//     button?.addEventListener("click", () => {
//       stickyAtc.classList.remove("visible");
//     });

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     window.addEventListener("resize", handleResize);

//     updateReachedEnd();
//     updateStickyState();
//   }

//   safeQuerySelector(selector) {
//     if (!selector) return null;

//     try {
//       return document.querySelector(selector);
//     } catch (error) {
//       console.warn(`Invalid sticky-atc selector: ${selector}`);
//       return null;
//     }
//   }
// }

// if (!customElements.get("sticky-atc")) {
//   customElements.define("sticky-atc", StickyAtc);
// }


class StickyAtc extends HTMLElement {
  connectedCallback() {
    const stickyAtc = this;
    const hideEnd = stickyAtc.hasAttribute("hide-end");

    const button = stickyAtc.querySelector(".sticky-atc__button");

    const targetSelector =
      stickyAtc.getAttribute("target-selector") || button?.getAttribute("href");

    const hideSelectorsRaw = stickyAtc.getAttribute("hide-selectors") || "";

    const hideSelectors = hideSelectorsRaw
      .split(",")
      .map((selector) => selector.trim())
      .filter(Boolean);

    // ✅ FIX: Only treat selector if it's a valid CSS selector (starts with # or .)
    let targetSection = null;
    if (targetSelector && (targetSelector.startsWith("#") || targetSelector.startsWith("."))) {
      targetSection = this.safeQuerySelector(targetSelector);
    }

    // ❗ IMPORTANT: Don't break everything if selector is invalid (URL case)
    if (!stickyAtc) return;

    let targetOutOfView = false;
    let reachedEnd = false;
    let insideHiddenSection = false;

    const hiddenSections = hideSelectors
      .map((selector) => this.safeQuerySelector(selector))
      .filter(Boolean);

    const updateReachedEnd = () => {
      const scrollPos = window.scrollY + window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      reachedEnd = hideEnd && scrollPos >= docHeight - 20;
    };

    const updateStickyState = () => {
      // ✅ If no targetSection (URL case), always allow visibility
      if (
        (!targetSection || targetOutOfView) &&
        !reachedEnd &&
        !insideHiddenSection
      ) {
        stickyAtc.classList.add("visible");
      } else {
        stickyAtc.classList.remove("visible");
      }
    };

    // ✅ Only observe if valid target exists
    if (targetSection) {
      const targetObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            targetOutOfView = !entry.isIntersecting;
            updateStickyState();
          });
        },
        {
          threshold: 0,
        },
      );

      targetObserver.observe(targetSection);
    } else {
      // If no selector (URL case), show sticky immediately
      targetOutOfView = true;
    }

    if (hiddenSections.length > 0) {
      const hiddenObserver = new IntersectionObserver(
        (entries) => {
          insideHiddenSection = entries.some((entry) => entry.isIntersecting);
          updateStickyState();
        },
        {
          threshold: 0,
          rootMargin: "0px 0px -20% 0px",
        },
      );

      hiddenSections.forEach((section) => {
        hiddenObserver.observe(section);
      });
    }

    const handleScroll = () => {
      updateReachedEnd();
      updateStickyState();
    };

    const handleResize = () => {
      updateReachedEnd();
      updateStickyState();
    };

    // ✅ FIX: Allow URL navigation, only intercept scroll links
    button?.addEventListener("click", (e) => {
      const href = button.getAttribute("href");

      if (href && href.startsWith("#")) {
        e.preventDefault();
        const el = document.querySelector(href);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }

      stickyAtc.classList.remove("visible");
    });

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);

    updateReachedEnd();
    updateStickyState();
  }

  safeQuerySelector(selector) {
    if (!selector) return null;

    try {
      return document.querySelector(selector);
    } catch (error) {
      console.warn(`Invalid sticky-atc selector: ${selector}`);
      return null;
    }
  }
}

if (!customElements.get("sticky-atc")) {
  customElements.define("sticky-atc", StickyAtc);
}